<div *ngIf="responsiveLayout">
  <input
    *ngIf="responsiveLayout"
    name="date"
    type="text"
    bsDatepicker
    [placeholder]="bsDatePickerConfig.dateInputFormat"
    class="form-control"
    [bsConfig]="bsDatePickerConfig"
    [(ngModel)]="date"
    (ngModelChange)="onDateTimeChanged()"
    (input)="onDateTyped($event)"
    [disabled]="disabled"
    [attr.data-testid]="dataTestId + '-date'"
    [maxDate]="disableFutureDates ? today : undefined"
    ngDefaultControl
    autocomplete="off"
  />
  <timepicker
    *ngIf="enableTimePicker"
    name="time"
    [showMeridian]="false"
    [showSpinners]="false"
    [mousewheel]="false"
    [(ngModel)]="time"
    (ngModelChange)="onDateTimeChanged()"
    [disabled]="disabled"
    [attr.data-testid]="dataTestId + '-time'"
    ngDefaultControl
  >
  </timepicker>
</div>

<div *ngIf="!responsiveLayout">
  <div class="d-flex gap-3">
    <div class="col-7">
      <input
        name="date"
        type="text"
        bsDatepicker
        [placeholder]="bsDatePickerConfig.dateInputFormat"
        class="form-control"
        [bsConfig]="bsDatePickerConfig"
        [(ngModel)]="date"
        (ngModelChange)="onDateTimeChanged()"
        (input)="onDateTyped($event)"
        [disabled]="disabled"
        [attr.data-testid]="dataTestId + '-date'"
        [maxDate]="disableFutureDates ? today : undefined"
        ngDefaultControl
        autocomplete="off"
      />
    </div>
    <div class="col-auto" *ngIf="enableTimePicker">
      <timepicker
        name="time"
        [showMeridian]="false"
        [showSpinners]="false"
        [mousewheel]="false"
        [(ngModel)]="time"
        (ngModelChange)="onDateTimeChanged()"
        [disabled]="disabled"
        [attr.data-testid]="dataTestId + '-time'"
        ngDefaultControl
      >
      </timepicker>
    </div>
  </div>
</div>
